import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import React, { useEffect, useState } from "react";
import LoaderSpiner from "../../../../components/loaderSpiner";
import { useLazyGetActivityQuery } from "../../../../services/Api";

export default function PackingListChart() {
  const [trigger, { data, isLoading, error }] = useLazyGetActivityQuery();
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    trigger()
      .unwrap()
      .then((response) => {

        const packingStats = response?.data?.data || [];

        const formattedData = packingStats.map((item) => ({
          x: item.x,
          y: item.y,
        }));

        setChartData(formattedData);
      })
      .catch((err) => {
      });
  }, [trigger]);

  if (isLoading) return <LoaderSpiner />;
  if (error) return <p>Error loading data.Please try again later.</p>;

  return (
    <div className="bg-lightgreen p-6 rounded-[1.75rem] md:h-full h-[370px]">
      <h3 className="mb-4 font-['Roboto_Mono'] text-lg font-bold">
        Activity Distribution{" "}
      </h3>
      <div className="h-[200px] -ml-6">
        <ResponsiveContainer width="110%" height="150%">
          <BarChart
            data={chartData}
            margin={{ top: 20, right: 30, left: 15, bottom: 5 }}
          >
            <XAxis
              dataKey="x"
              label={{ position: "insideBottom", offset: -5 }}
            />
            <YAxis label={{ angle: -90, position: "insideLeft" }} />
            <Tooltip />
            <Bar dataKey="y" fill="#3D5673" barSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
